// config
import * as http from 'utils/http';
import config from 'config';

const createComment = async ({ ticketId, body }) => {
  return http.post(`${config.API_URL}price-negotiation/tickets/${ticketId}/comments/`, body);
};

export default createComment;
